<template>
  <div class="page">
    <b-jumbotron fluid>
      <h1 class="h3">Walne Zebranie Użytkowników</h1>
    </b-jumbotron>

    <div class="container">
      <h2 class="h3 pb-2 mb-3 border-bottom">Podsumowanie</h2>
      <p>
        13 grudnia 2019 roku o godzinie 18:00 w Szkole Podstawowej 343, odbyło się Walne Zebranie
        Użytkowników.
      </p>
      <p>
        W Zebraniu uczestniczyły osoby reprezentujące
        <b>36 spośród 68 miejsc</b> parkingowych (52,9%). Wydano 36 kart do głosowania, na koniec
        zebrania zwrócono 35 kart.<br/>
        W ciągu <b>2 godzin</b> podjęliśmy <b>7 uchwał</b> i rozpatrzyliśmy <b>5 wniosków</b>.
      </p>
      <p>
        Dziękujemy serdecznie za obecność i czynny udział. Dzięki Państwa głosom i sugestiom
        podjęliśmy niezwykle istotne decyzje, które pozwolą usprawnić nasz parking.
      </p>

      <h2 class="h3 pb-2 mb-3 border-bottom">Uchwały</h2>

      <ul class="list-group">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.01.pdf" target="_blank">
                Uchwała nr 1/2019 w sprawie <b>przyjęcia porządku obrad</b>
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">35</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">35</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">-</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <p>
                <a href="/files/walne-2019/walne_uch.02.pdf" target="_blank">
                  Uchwała nr 2/2019 w sprawie zatwierdzenia <b>sprawozdania Społecznego Komitetu
                  Parkingowego</b>
                </a>
              </p>

              <p class="mb-0">
                <a href="/files/walne-2019/walne_uch.02.zal.1.pdf" target="_blank">
                  Załącznik do uchwały nr 2/2019 - sprawozdanie Społecznego Komitetu Parkingowego
                </a>
              </p>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">35</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">29</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">6</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <p>
                <a href="/files/walne-2019/walne_uch.03.pdf" target="_blank">
                  Uchwała nr 3/2019 w sprawie zatwierdzenia <b>Regulaminu Parkingu Społecznego</b>
                </a>
              </p>
              <p>
                <a href="/files/walne-2019/walne_uch.03.zal.1.pdf" target="_blank">
                  Załącznik do uchwały nr 3/2019 - Regulamin Parkingu Społecznego
                </a>
              </p>
              <p class="mb-0">
                <a href="/files/walne-2019/walne_uch.03.zal.2.pdf" target="_blank">
                  Załącznik nr 1 do Regulaminu - Uchwała nr 81/2019 Zarządu SM "Na Skraju"
                </a>
              </p>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">27</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">1</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">5</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.04.pdf" target="_blank">
                Uchwała nr 4/2019 w sprawie udzielenia zgody na przeprowadzenie <b>modernizacji
                bramy
                wjazdowej</b>
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">34</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">34</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">-</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.05.pdf" target="_blank">
                Uchwała nr 5/2019 w sprawie <b>utworzenia funduszu społecznego</b> na utrzymanie
                parkingu
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">31</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">2</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.06.pdf" target="_blank">
                Uchwała nr 6/2019 w sprawie <b>wnoszenia innych opłat</b> naliczonych i wymaganych,
                ale nie wliczonych do czynszu przez Spółdzielnię
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">34</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">1</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.07.pdf" target="_blank">
                Uchwała nr 7/2019 w sprawie udzielenia zgody na przeprowadzenie <b>modernizacji
                furtek</b>
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">35</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">2</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.08.pdf" target="_blank">
                Uchwała nr 8/2019 w sprawie możliwości <b>powiązania prawa do miejsca parkingowego z
                mieszkaniem</b>
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">28</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">3</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">2</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.09.pdf" target="_blank">
                Uchwała nr 9/2019 w sprawie <b>likwidacji trzeciego miejsca</b> w wewnętrznym
                pierścieniu w
                celu poszerzenia pozostałych
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">19</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">9</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">5</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <p>
                <a href="/files/walne-2019/walne_uch.10.pdf" target="_blank">
                  Uchwała nr 10/2019 w sprawie udzielenia zgody na <b>pokrycie kosztów
                  organizacji</b> Walnego Zebrania Użytkowników z funduszu społecznego
                </a>
              </p>
              <p>
                <a href="/files/walne-2019/walne_uch.10.zal.1.pdf" target="_blank">
                  Załącznik nr 1 do uchwały nr 10/2019 - faktura od Urzędu Miasta na kwotę 147,60 brutto
                </a>
              </p>
              <a href="/files/walne-2019/walne_uch.10.zal.2.pdf" target="_blank">
                Załącznik nr 2 do uchwały nr 10/2019 - potwierdzenie płatności
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">-</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.11.pdf" target="_blank">
                Uchwała nr 11/2019 w sprawie <b>odwołania p. Ewy Kasińskiej</b> ze składu Społecznego Komitetu Parkingowego
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">25</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">8</span>
              </div>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9">
              <a href="/files/walne-2019/walne_uch.12.pdf" target="_blank">
                Uchwała nr 12/2019 w sprawie <b>przyjęcia Pani Natalii Potockiej</b> do składu Komitetu Parkingowego
              </a>
            </div>
            <div class="col text-right">
              <div>
                Głosów ważnych: <span class="badge badge-primary" style="width: 30px;">33</span>
              </div>
              <div>
                Głosów "za": <span class="badge badge-success" style="width: 30px;">29</span>
              </div>
              <div>
                Głosów "przeciw": <span class="badge badge-danger" style="width: 30px;">-</span>
              </div>
              <div>
                Głosów "wstrzymujących się":
                <span class="badge badge-warning" style="width: 30px;">4</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'walne-2019',
};
</script>
